



export const ongoFabProjects = [
    {
        id:1,
        photoIcon: [
            "./ongoing/Ongo_29.jpg", "./ongoing/Ongo_29_1.jpg","./ongoing/Ongo_29_2.jpg","./ongoing/Ongo_29_3.jpg"
        ],
        client: "NEO STRUCTO",
        customer:"UTKAL ALUMINA INTERNATIONAL LTD",
        location:"TIKRI",
        project:"ERECTION OF STRUCTURAL STEEL, EQUIPMENT, PIPING FOR ALUMINA REFINERY EXPANSION PROJECT AT TIKRI, ODISHA"
    },
    {
        id:2,
        photoIcon: [
            "./ongoing/Ongo_32.jpg", "./ongoing/Ongo_32_1.jpg","./ongoing/Ongo_32_2.jpg","./ongoing/Ongo_32_3.jpg"
        ],
        client: "NEO STRUCTO",
        customer:"UTKAL ALUMINA INTERNATIONAL LTD",
        location:"TIKIRI",
        project:" FABRICATION OF STRUCTURALS AT OUR BHILAI WORKS UNIT  FOR ALUMINA REFINERY PROJECT AT TIKRI, ODISHA."
    },
    {
        id:3,
        photoIcon: [
            "./ongoing/Ongo_26.jpg", "./ongoing/Ongo_26_1.jpg","./ongoing/Ongo_26_2.jpg","./ongoing/Ongo_26_3.jpg"
        ],
        client: "ABB INDIA LTD",
        customer:"HINDUSTAN ZINC LTD",
        location:"RAJASTAN",
        project:"FABRICATION OF SKID INCLUDING SUPPLY OF STEEL AT OUR BHILAI WORKS UNIT FOR HINDUSTAN ZINC LIMITED  ZAWAR AND RA MINES, RAJASTHAN, INDIA"
    },
    {
        id:4,
        photoIcon: [
            "./ongoing/Ongo_25.jpg", "./ongoing/Ongo_25_1.jpg","./ongoing/Ongo_25_2.jpg","./ongoing/Ongo_25_3.jpg"
        ],
        client: "BHEL",
        customer:"NMDC- NAGARNAR(CG)",
        location:"NAGRNAR",
        project:"FIXING  OF COLOUR COATED SHEET FOR RMHS PACAKGE NMDC, NAGARNAR, CHHATTISGARH."
    },
    {
        id:5,
        photoIcon: [
            "./ongoing/Ongo_27.jpg", "./ongoing/Ongo_27_1.jpg","./ongoing/Ongo_27_2.jpg","./ongoing/Ongo_27_3.jpg"
        ],
        client: "ATMASCO LTD",
        customer:"JSW",
        location:"MAHARASHTRA",
        project:"FABRICATION OF HEAVY STRUCTURAL INCLUDING STEEL SUPPLY AT OUR BHILAI WORKS UNIT FOR  JSW DOLVI PROJECT, MAHARASHTRA"
    },
    {
        id:6,
        photoIcon: [
            "./ongoing/Ongo_28.jpg", "./ongoing/Ongo_28_1.jpg","./ongoing/Ongo_28_2.jpg","./ongoing/Ongo_28_3.jpg"
        ],
        client: "TATA PROJECTS LIMITED",
        customer:"NTPC TPP TALCHER",
        location:" ODISHA",
        project:" FABRICATION OF STRUCTURALS INCLUDING STEEL SUPPLY AT OUR BHILAI WORKS UNIT  FOR BUILDING,CONVEYOR, PIPE & CABLE RACK ETC. FOR FGD PROJECTS AT NTPC TPP."
    },
    {
        id:7,
        photoIcon: [
            "./ongoing/Ongo_28.jpg", "./ongoing/Ongo_28_1.jpg","./ongoing/Ongo_28_2.jpg","./ongoing/Ongo_28_3.jpg"
        ],
        client: "ZETWERK MANUFACTURING BUSINESSES PRIVATE LIMITED.",
        customer:"JNK / IOCL",
        location:" ",
        project:"FABRICATION OF STRUCTURE AND SUPPLY OF STEEL AT OUR BHILAI WORKS UNIT  FOR JNK/IOCL PARADIP PX-PTA PROJECT."
    },
    
]